import { useContext } from "react";

import { ActivityBlockerContext } from "../contexts";

export function useActivityBlocker() {
  return useContext(ActivityBlockerContext);
}
